export default class RestaurentFoodModel {
    constructor({
      dbID,
      availability,
      categoryName,
      categoryType,
      department,
      description,
      discount,
      foodQuantity,
      gst,
      happyHour,
      image,
      information,
      kitchen,
      kitchenId,
      menuId,
      name,
      particular,
      price,
      productId,
      quantity,
      restaurantId,
      timeFrom,
      timeTo,
      type,
      timeTo2,
      timeTo3,
      timeFrom2,
      timeFrom3,
      settlementPrice,
      onFieldPrice,
      petPoojaExternalId,
      petPoojaItemId,
      visibility,
      foodName,
      foodId
    }) {
      this.dbID = dbID;
      this.availability = availability;
      this.categoryName = categoryName;
      this.categoryType = categoryType;
      this.department = department;
      this.description = description;
      this.discount = discount;
      this.foodQuantity = foodQuantity;
      this.gst = gst;
      this.happyHour = happyHour;
      this.image = image;
      this.information = information;
      this.kitchen = kitchen;
      this.kitchenId = kitchenId;
      this.menuId = menuId;
      this.name = name;
      this.particular = particular;
      this.price = price;
      this.productId = productId;
      this.quantity = quantity;
      this.restaurantId = restaurantId;
      this.timeFrom = timeFrom;
      this.timeTo = timeTo;
      this.type = type;
      this.timeTo2 = timeTo2;
      this.timeTo3 = timeTo3;
      this.timeFrom2 = timeFrom2;
      this.timeFrom3 = timeFrom3;
      this.settlementPrice = settlementPrice;
      this.onFieldPrice = onFieldPrice;
      this.petPoojaExternalId = petPoojaExternalId;
      this.petPoojaItemId = petPoojaItemId;
      this.visibility =visibility;
      this.foodName = foodName;
      this.foodId = foodId;

    }
  
    static fromJson(id, json) {
      return new RestaurentFoodModel({
        dbID: id,
        availability: availabilityValues.map[json.availability] ?? Availability.NO,
        categoryName: json.categoryName ?? "",
        categoryType: json.categoryType,
        department: json.department,
        description: json.description,
        discount: json.discount,
        foodQuantity: json.foodQuantity,
        gst: availabilityValues.map[json.gst] ?? Availability.YES,
        happyHour: json.happyHour ?? "",
        image: json.image ?? "",
        information: json.information,
        kitchen: json.kitchen ?? "",
        kitchenId: json.kitchenId ?? "",
        menuId: json.menuId ?? "",
        name: json.name,
        particular: json.particular,
        price: json.price,
        productId: json.productId,
        quantity: json.quantity,
        restaurantId: json.restaurantId,
        timeFrom: json.timeFrom,
        timeTo: json.timeTo,
        type: typeValues.map[json.type] ?? FoodType.NO,
        timeTo2: json.timeTo2 ?? "",
        timeTo3: json.timeTo3 ?? "",
        timeFrom2: json.timeFrom2 ?? "",
        timeFrom3: json.timeFrom3 ?? "",
        settlementPrice: json.settlementPrice ?? "0",
        onFieldPrice: json.onFieldPrice ?? "0",
        petPoojaExternalId: json.petPoojaExternalId ?? "",
        petPoojaItemId: json.petPoojaItemId ?? "",
        visibility : json.visibility ?? "Yes", 
        foodId : json.foodId ?? "",
        foodName : json.foodName ?? ""
      });
    }
  
    toJson() {
      return {
        dbID : this.dbID,
        availability: availabilityValues.reverse[this.availability] ?? "",
        categoryName: this.categoryName,
        categoryType: this.categoryType,
        department: this.department,
        description: this.description,
        discount: this.discount,
        foodQuantity: this.foodQuantity,
        gst: availabilityValues.reverse[this.gst] ?? Availability.YES,
        happyHour: "",
        image: this.image,
        information: this.information,
        kitchen: this.kitchen,
        kitchenId: this.kitchenId,
        menuId: this.menuId,
        name: this.name,
        particular: this.particular,
        price: this.price,
        productId: this.productId,
        quantity: this.quantity,
        restaurantId: this.restaurantId,
        timeFrom: this.timeFrom,
        timeTo: this.timeTo,
        type: typeValues.reverse[this.type],
        timeTo2: this.timeTo2,
        timeFrom2: this.timeFrom2,
        timeFrom3: this.timeFrom3,
        timeTo3: this.timeTo3,
        settlementPrice: this.settlementPrice,
        onFieldPrice: this.onFieldPrice,
        petPoojaExternalId: this.petPoojaExternalId,
        petPoojaItemId: this.petPoojaItemId,
        visibility : this.visibility
      };
    }
  }
  
  export  const Availability = {
    YES: "Yes",
    NO: "No"
  };
  
  export const availabilityValues = {
    map: {
      "": Availability.NO,
      "No": Availability.NO,
      "Yes": Availability.YES
    },
    reverse: {
      [Availability.NO]: "",
      [Availability.YES]: "Yes"
    }
  };
  
 export  const FoodType = {
    VEG: "Veg",
    NON_VEG: "Non-Veg",
    NO: ""
  };
  
  export  const typeValues = {
    map: {
      "": FoodType.NO,
      "Non-Veg": FoodType.NON_VEG,
      "Veg": FoodType.VEG
    },
    reverse: {
      [FoodType.NO]: "",
      [FoodType.NON_VEG]: "Non-Veg",
      [FoodType.VEG]: "Veg"
    }
  };
  